<template>
  <div>
    <calling-code class="area-code"></calling-code>

    <div class="form-group phone-number">
      <label for="phone">{{ $t('phoneNumPlaceholder') }}</label>
      <input 
        type="text" 
        name="phone"
        id="phone"
        :placeholder="$t('phoneNumPlaceholder')"
        v-model="phoneNumber"
        v-validate="'required|numeric'"
        @keyup.enter="getCaptchaCode"
        @blur="showErrors.phone = true"
        :class="{'input': true, 'danger-border': errors.has('phone') || !!phoneErrorMessage}">
      <p class="error-info">
        <span v-show="errors.has('phone') && showErrors.phone">{{ errors.first('phone') }}</span>
        <span v-show="showErrors.phone">{{ phoneErrorMessage }}</span>
      </p>
    </div>
    <p class="clearfix"></p>

    <div class="form-group get-captcha-code">
      <label for="yourCode">{{ $t('verificationPlaceholder') }}</label>
      <button v-show="!sendCodeLoading" @click="getCaptchaCode" :disabled="time > 0 || isDisabled">
        <span v-if="time > 0" class="wait">{{ $t('sent') }} {{ time }} s</span>
        <span v-else>{{ timerText }}</span>
      </button>
      <input 
        autocomplete="off" 
        type="text" 
        name="verificationCode"
        id="yourCode"
        :placeholder="$t('verificationPlaceholder')"
        v-model="verificationCode"
        v-validate="'required|digits:5'"
        @blur="showErrors.verificationCode = true"
        :class="{'input': true, 'danger-border': errors.has('verificationCode') || !!verificationCodeErrorMessage}">
      <p class="error-info">
        <span v-show="errors.has('verificationCode') && showErrors.verificationCode">{{ errors.first('verificationCode') }}</span>
        <span v-show="showErrors.verificationCode">{{ verificationCodeErrorMessage }}</span>
      </p>
    </div>

    <button class="form-submit line-button" v-if="!isSubmitLoading" @click="getResetToken">
      {{ $t('submit') }}
    </button>
    <spinner :show="isSubmitLoading" class="spinner-component"></spinner>

    <captcha @verification="sendVerificationCode" :phoneNumber="phoneNumber" :captchaSubmitLoading="captchaSubmitLoading" :invalidCode="invalidCode" :getCaptchaCodeLoading="getCaptchaCodeLoading"></captcha>
  </div>
</template>

<script>
  import Spinner from '../Spinner.vue'
  import CallingCode from '../callingCode/IndexMain.vue'
  import Captcha from '../captcha/Captcha.vue'
  import locales from './lang'
  import $ from 'jquery'

  export default {
    name: 'reset-phone-pwd',
    components: {
      Spinner,
      CallingCode,
      Captcha
    },
    data: function () {
      return {
        phoneNumber: '',
        phoneErrorMessage: '',
        isDisabled: false,
        sendCodeLoading: false,
        timerText: this.$t('getVerificationCode'),
        time: 0,
        verificationCode: '',
        verificationCodeErrorMessage: '',
        sendAgain: this.$t('sendAgain'),
        getVerificationCode: this.$t('getVerificationCode'),
        isShowPwd: false,
        isSubmitLoading: false,
        networkError: this.$t('networkError'),
        showErrors: {
          'phone': false,
          'verificationCode': false
        },
        getCaptchaCodeLoading: false,
        invalidCode: false,
        captchaSubmitLoading: false
      }
    },
    locales,
    computed: {
      dialCode() {
        return this.$store.state.dialCode
      }
    },
    watch: {
      phoneNumber() {
        this.showErrors.phone = false
        this.phoneErrorMessage = ''
      },
      verificationCode() {
        this.showErrors.verificationCode = false
        this.verificationCodeErrorMessage = ''
      }
    },
    methods: {
      getCaptchaCode: function () {
        if (this.time !== 0) return
        if (this.dialCode === '') return
        this.$validator.validateAll({phone: this.phoneNumber}).then(success => {
          if (!success) return
          this.invalidCode = false
          this.getCaptchaCodeLoading = true
          $('#captcha').modal('show')
          this.$store.dispatch('getCaptchaLink', this.phoneNumber).then((code) => {
            if (code === 0) {
              this.getCaptchaCodeLoading = false
            }
          })
        })
      },
      sendVerificationCode: function (captcha) {
        this.invalidCode = false
        this.captchaSubmitLoading = true
        this.isDisabled = true
        this.showErrors.phone = true
        if (this.errors.has('phone')) {
          return
        }
        this.$validator.validateAll({phone: this.phoneNumber}).then(success => {
          if (!success) {
            return
          }
          this.phoneErrorMessage = ''
          this.sendCodeLoading = true
          this.$http.post('api/verification/phone', {
            phone_num: this.phoneNumber,
            calling_code: this.dialCode,
            type: 'password_reset',
            captcha: captcha
          }).then((response) => {
            this.isDisabled = false
            this.sendCodeLoading = false
            this.captchaSubmitLoading = false
            switch (response.data.code) {
              case 0: {
                this.time = 60
                this.isDisabled = true
                this.runTimer()
                $('#captcha').modal('hide')
                break
              }
              case 120: {
                this.invalidCode = true
                break
              }
              default: {
                $('#captcha').modal('hide')
                this.phoneErrorMessage = response.data.message
                break
              }
            }
          }, (response) => {
            this.captchaSubmitLoading = false
            $('#captcha').modal('hide')
            this.phoneErrorMessage = this.networkError
            this.sendCodeLoading = false
            this.isDisabled = false
          })
        })
      },
      runTimer: function () {
        if (this.time > 0) {
          this.timerText = --this.time !== 0 ? this.sendAgain : this.getVerificationCode
          setTimeout(this.runTimer, 1000)
        } else {
          this.isDisabled = false
        }
      },
      getResetToken() {
        for (let i in this.showErrors) {
          this.showErrors[i] = true
        }
        if (this.errors.errors.length > 0) {
          return
        }
        this.$validator.validateAll().then(success => {
          if (!success) {
            return
          }
          this.phoneErrorMessage = ''
          this.verificationCodeErrorMessage = ''
          this.isSubmitLoading = true
          this.$http.post('api/check-verification-code', {
            calling_code: this.dialCode,
            type: 'phone',
            phone_num: this.phoneNumber,
            verification_code: this.verificationCode
          }).then((response) => {
            this.isSubmitLoading = false
            switch (response.data.code) {
              case 0: {
                this.$router.push('reset-password?phone=' + this.phoneNumber + '&reset_token=' + response.data.data.token)
                break
              }
              case 120: {
                this.verificationCodeErrorMessage = response.data.message
                break
              }
              default: this.phoneErrorMessage = response.data.message
            }
          }, (response) => {
            this.verificationCodeErrorMessage = this.networkError
            this.isSubmitLoading = false
          })
        })
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/formstyle";

  div.form-group {
    input {
      margin-top: .08rem;
      height: .54rem;
      line-height: .54rem;
      border: 1px solid #E0D7E3;
      border-radius: 42px;
      padding: 0 24px;
      font-size: 16px;
      &::placeholder {
        color: #ccc;
      }
    }
  }
  .form-submit {
    margin: .16rem 0 0;
    height: 54px;
    line-height: 54px;
    font-size: 18px;
    font-weight: 600;
    background-image: linear-gradient(125deg, #416CF8 0%, #EC55FF 100%);
    border-radius: 42px;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 4px;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(125deg, #416cf8 0%, #ec55ff 100%);
      border-radius: 42px;
      filter: blur(4px);
      -webkit-filter: blur(4px);
      -moz-filter: blur(4px);
      -ms-filter: blur(4px);
      -o-filter: blur(4px);
      z-index: -1;
    }
  }

  input::-webkit-contacts-auto-fill-button {
    visibility: hidden;
    display: none !important;
    pointer-events: none;
  }

  .get-captcha-code {
    button {
      position: absolute;
      top: 55px;
      right: 16px;
      font-size: .16rem;
      background: transparent;
      color: #416CF8;
      letter-spacing: 0.7px;
    }
    .wait {
      color: #BDBDBD;
    }
    input {
      clear: both;
    }
  }

  .spinner-component {
    margin: .36rem auto .4rem auto;
  }

  
  @media (max-width: 767px) {
    div.form-group {
      input {
        height: 0.49rem;
        line-height: .49rem;
        font-size: 14px;
        padding: 0 16px;
      }
    }
    .error-info {
      margin-top: 0.02rem;
    }
    .form-submit {
      margin-top: .24rem;
      height: 49px;
      line-height: 49px;
      font-size: 16px;
    }
    .get-captcha-code button {
      top: 43px;
      font-size: .14rem;
    }
  }
</style>



// WEBPACK FOOTER //
// IndexMain.vue?f12d941c